import { FetchError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';

const getAddConversationPath = (spaceId: string) => `${SPACES_API_PATH}/${spaceId}/conversations`;

export type AddConversationToSpaceRequest = {
	spaceId: string;
	conversationId: string;
};

export type AddConversationToSpaceFetchParams = {
	request: AddConversationToSpaceRequest;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const addConversationToSpaceFetchAction = async ({
	request,
	cloudId,
	product,
	experienceId,
}: AddConversationToSpaceFetchParams): Promise<void> => {
	const path = getAddConversationPath(request.spaceId);
	let response: Response;
	try {
		response = await fetch(path, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
			body: JSON.stringify({ conversationId: request.conversationId }),
		});
	} catch (err) {
		const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
		throw new FetchError(
			`addConversationToSpaceFetch error while fetching ${path}. Original error: ${originalErrorMessage}`,
			{ errorCode: 'addConversationToSpaceFetchError' },
		);
	}
	if (!response.ok || response.status >= 400) {
		const body = await response.text().catch(() => '');
		throw new FetchError(
			`addConversationToSpaceFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`,
			{ errorCode: 'addConversationToSpaceFetchError', statusCode: response.status },
		);
	}
};
